import HeroSection from "../components/HeroSection";
import KeyHighlights from "../components/KeyFeatures"
import LocationSnapshot from '../components/LocationSnapshot';
import PremiumVillas from '../components/PremiumVillas';
import LifestylePromise from '../components/LifestylePromise';
// import LifestyleGallery from '../components/HomeGalleryTypes';
import FloretWalkThrough from '../components/FloretWalkThrough';
import SeoHelper from '../common/SeoHelper';
const Home = () => {
  return (
    <section>
        <SeoHelper/>
        <HeroSection/>
        <FloretWalkThrough/>
        <KeyHighlights/>
        <PremiumVillas/>
        {/* <LifestyleGallery/> */}
        <LocationSnapshot/>
        <LifestylePromise/>
    </section>
  );
};

export default Home;
